
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-study-app",
      function () {
        return require("private-next-pages/online-study-app.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online-study-app"])
      });
    }
  